import styled from '@emotion/styled';

/**
 * CoverPage — Page 1 of the Kuutio print report.
 *
 * Black background, instance title top-left, gradient cube center,
 * subtitle + Sitra logo bottom. Matches InDesign K3 p1 exactly.
 */
export default function CoverPage({ instanceNumber = '3', title, subtitle }) {
  return (
    <Page className="page cover-page">
      <TopSection>
        <InstanceLabel>
          <KuutioBold>KUUTIO #{instanceNumber}:</KuutioBold>{' '}
          {title}
        </InstanceLabel>
      </TopSection>

      <CubeSection>
        {/* KUUTIO text-logo with cube — the big white letters with gradient cube inside */}
        <KuutioTextLogo>
          <img
            src="/assets/report/kuutio-logo-black.png"
            alt="Kuutio"
            style={{ width: '340px', height: 'auto' }}
          />
        </KuutioTextLogo>
      </CubeSection>

      <BottomSection>
        <Subtitle>{subtitle}</Subtitle>
        <SitraLogo>
          {/* Sitra logo as SVG text — matches the brand wordmark */}
          <svg viewBox="0 0 120 30" width="120" height="30" xmlns="http://www.w3.org/2000/svg">
            <text
              x="0" y="24"
              fill="white"
              fontFamily="'Rational', 'Helvetica Neue', sans-serif"
              fontSize="28"
              fontWeight="900"
              letterSpacing="2"
            >
              SITRA
            </text>
          </svg>
        </SitraLogo>
      </BottomSection>
    </Page>
  );
}

const Page = styled.div`
  width: 297mm;
  min-height: 210mm;
  background: #000;
  color: #fff;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 40px 50px;
  box-sizing: border-box;
  font-family: 'Rational', sans-serif;
  overflow: hidden;

  @media print {
    break-after: page;
    margin: 0;
    padding: 40px 50px;
  }
`;

const TopSection = styled.div`
  flex: 0 0 auto;
`;

const InstanceLabel = styled.h1`
  font-size: 28px;
  font-weight: 400;
  line-height: 1.2;
  max-width: 500px;
  letter-spacing: -0.3px;
`;

const KuutioBold = styled.span`
  font-weight: 900;
  letter-spacing: 0.5px;
`;

const CubeSection = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const KuutioTextLogo = styled.div`
  /* The gradient cube image centered on the page */
`;

const BottomSection = styled.div`
  flex: 0 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

const Subtitle = styled.div`
  font-size: 20px;
  font-weight: 400;
  line-height: 1.4;
  max-width: 300px;
`;

const SitraLogo = styled.div`
  /* Bottom-right corner */
`;
